import React from 'react'
import {
  DatePicker as CDatePicker,
  DatePickerProps as CDatePickerProps,
  Tooltip,
} from 'antd'
import styles from './DatePicker.module.scss'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

type DatePickerProps = {
  errorMessage?: string
  isError?: boolean
  suffixConfig?: { icon: React.ReactNode, text: string }
} & CDatePickerProps

export default function DatePicker({
  errorMessage = '',
  suffixIcon,
  suffixConfig,
  isError = false,
  ...restProps
}: DatePickerProps) {
  const {t}  = useTranslation();
  return (
    <div className={styles.wrapperPicker}>
      <CDatePicker status={isError ? 'error': ''} className={styles.datepicker} {...restProps} />
      {(isError || suffixConfig) && (
        <div className={styles.tooltip}>
          <Tooltip overlayClassName={isError ? styles.customTooltip: ''} title={isError ? t(errorMessage) : suffixConfig?.text}>
            <div className={styles.errorTooltipIcon}>
              { isError ? <InfoCircleOutlined style={{ color: '#f3646c' }} /> : suffixConfig?.icon }
            </div>
          </Tooltip>
        </div>
      )}
    </div>
  )
}
